import { html } from "lit";
import { ContactSliderTemplate } from "./contact-slider.templates";
import { DownloadSliderTemplate } from "./download-slider.templates";
import { EventSliderTemplate } from "./event-slider.templates";
import { PageSliderTemplate } from "./page-slider.templates";
import { ProductSliderTemplate } from "./product-slider.templates";
import { VideoSliderTemplate } from "./video-slider.templates";

const renderSearchResultsSummary = (name, tab) => html`
    <!-- BEGIN result summary -->
    <div class="ux-iws-search-results__summary">
        <div class="ux-text-headline ux-text-headline--small ux-u-text-bold">
            ${name}
            <a
                class="ux-text-link ux-text-link--green ux-u-margin-left-10"
                href="#"
                data-ux-tab-target="${tab}"
            >
                Alle anzeigen
            </a>
        </div>
    </div>
    <!-- END result summary -->
`;

const summaryContainerClassName = "ux-u-margin-bottom-20";
const sliderContainerClassName = "ux-u-mb-fluid-s";

export const AllResultsTemplate = () => html`
    <!-- BEGIN products -->
    <div class="${summaryContainerClassName}">
        ${renderSearchResultsSummary("Produkte (65)", "products ")}
    </div>
    <div class="${sliderContainerClassName}">
        ${ProductSliderTemplate({ tab: "products " })}
    </div>
    <!-- BEGIN downloads -->
    <div class="${summaryContainerClassName}">
        ${renderSearchResultsSummary("Downloads (8)", "downloads ")}
    </div>
    <div class="${sliderContainerClassName}">
        ${DownloadSliderTemplate({ tab: "downloads " })}
    </div>
    <!-- BEGIN pages -->
    <div class="${summaryContainerClassName}">
        ${renderSearchResultsSummary("Seiten (40)", "pages ")}
    </div>
    <div class="${sliderContainerClassName}">
        ${PageSliderTemplate({ tab: "pages " })}
    </div>
    <!-- BEGIN contacts -->
    <div class="${summaryContainerClassName}">
        ${renderSearchResultsSummary("Kontakte (4)", "contacts ")}
    </div>
    <div class="${sliderContainerClassName}">
        ${ContactSliderTemplate({ tab: "contacts " })}
    </div>
    <!-- BEGIN events -->
    <div class="${summaryContainerClassName}">
        ${renderSearchResultsSummary("Termine (2)", "events ")}
    </div>
    <div class="${sliderContainerClassName}">
        ${EventSliderTemplate({ tab: "events " })}
    </div>
    <!-- BEGIN videos -->
    <div class="${summaryContainerClassName}">
        ${renderSearchResultsSummary("Videos (12)", "videos ")}
    </div>
    <div class="${sliderContainerClassName}">
        ${VideoSliderTemplate({ tab: "videos " })}
    </div>
`;
